<div class="cogx-dialog">
    <div class="cogx-header">
      <button type="button" class="close-btn" (click)="close()" aria-label="Close COGX Info">
        &times;
      </button>
  
      <img src="assets/logos/zai.svg" alt="COGX Logo" class="cogx-logo" />
      <h2>COGX</h2>
      <span class="badge-optimal">AI Image + Video • Prompt-to-Visual • Creative Generation</span>
    </div>
  
    <div class="cogx-body">
  
      <p class="intro">
        <strong>COGX</strong> is a modern
        <span class="highlight">AI image and video generation tool</span>
        built to turn text prompts into high-quality visuals.
        It’s designed for fast creative iteration — from concept art and product mockups to short-form video scenes —
        with controls that help users refine style, composition, and output consistency.
        <br /><br />
        <strong>Created by:</strong>
        <span class="highlight">Researchers from Qingying (Zhipu AI / THUDM) and Tsinghua University</span>
      </p>
  
      <ul class="qualities">
        <li>
          <span class="icon">🖼️</span>
          <span>
            <strong>Prompt-to-Image Creation:</strong>
            Generate original images from text prompts for design, marketing, storyboards, and creative exploration.
          </span>
        </li>
  
        <li>
          <span class="icon">🎥</span>
          <span>
            <strong>Prompt-to-Video Generation:</strong>
            Create short video clips from a prompt, useful for concept scenes, motion ideas, and quick visual prototypes.
          </span>
        </li>
  
        <li>
          <span class="icon">🎨</span>
          <span>
            <strong>Style & Aesthetic Control:</strong>
            Guide outputs with style keywords, mood, lighting, and camera language to match a specific look.
          </span>
        </li>
  
        <li>
          <span class="icon">🧩</span>
          <span>
            <strong>Iteration & Variations:</strong>
            Quickly produce multiple variations from a single idea to compare options and refine direction.
          </span>
        </li>
  
        <li>
          <span class="icon">📐</span>
          <span>
            <strong>Composition & Scene Guidance:</strong>
            Strong at following structured prompts that specify subject, setting, framing, and details.
          </span>
        </li>
  
        <li>
          <span class="icon">✅</span>
          <span>
            <strong>Practical for Production Workflows:</strong>
            Useful for generating assets, creative drafts, and visual concepts that teams can build on.
          </span>
        </li>
      </ul>
  
      <div class="when-use">
        <h3>Why Users Choose COGX</h3>
        <ul>
          <li><strong>Rapid concepting</strong> for images and short video ideas</li>
          <li><strong>Marketing creatives</strong> like ads, thumbnails, and promos</li>
          <li><strong>Storyboarding</strong> and pre-visualization for scenes</li>
          <li><strong>Style exploration</strong> across multiple aesthetics quickly</li>
          <li><strong>Asset generation</strong> for creative and content pipelines</li>
        </ul>
  
        <div class="tip">
          <span>💡</span>
          <span>
            <strong>Pro Tip:</strong> For best results, write prompts in layers:
            subject → setting → lighting → style → camera/framing → details.
          </span>
        </div>
  
        <div class="comparison">
          <h3>What Makes COGX Feel “Creative” in Real Use</h3>
          <p>
            COGX feels creative because it turns high-level ideas into visual directions fast —
            and helps you iterate until it matches what you imagined. Users typically notice:
          </p>
          <ul>
            <li>Faster visual ideation compared to manual searching or drafting</li>
            <li>More variety and style range from small prompt changes</li>
            <li>Better results when prompts include lighting + framing cues</li>
            <li>Strong utility for concept art, mockups, and short video prototypes</li>
          </ul>
        </div>
      </div>
  
    </div>
  </div>
  